import './RichNote.css';

import React from 'react';
import { Close } from '@mui/icons-material';
import B2BDialog from '../../../b2b-common/B2BDialog';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const RichNote = ({ itemNote, showNote = false, onclose: onClose }) => {
    const { t } = useB2BTranslation('b2b-logbook');
    return (
        <B2BDialog open={showNote} title={itemNote ? itemNote.logBookItemName : ''} onClose={onClose}
            className='rich-note-view'
            buttons={[
                {
                    label: t('Close'),
                    onClick: (event) => {
                        event.stopPropagation();
                        onClose();
                    },
                    icon: <Close />
                }]
            }
        >
            <div className='rich-note-view-description'>
                {itemNote ? itemNote.logBookItemDescription : ''}
            </div>
            <div dangerouslySetInnerHTML={{ __html: itemNote ? itemNote.logBookItemNoteText : null }} />
        </B2BDialog>
    )

}

export default RichNote;